<div class="one" fxLayout="column" [formGroup]="TrainingForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TRAININGDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TRAININGDATE),
      }"
    >
      <mat-label>Training Date</mat-label>
      <input
        (dateInput)="CommencementDateClick('input', $event)"
        formControlName="TRAININGDATETEXT"
        (dateChange)="CommencementDateClick('change', $event)"
        matInput
        [matDatepicker]="CommencementDate"
        matTooltip="{{ toolTipList ? toolTipList.TRAININGDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="CommencementDate"></mat-datepicker-toggle>
      <mat-datepicker #CommencementDate></mat-datepicker>
      @if (testBool && toolTipList.TRAININGDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.TRAININGDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.TRAININGDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TRAININGNUMDAYS),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TRAININGNUMDAYS),
      }"
    >
      <mat-label>Number of Days</mat-label>
      <input
        matInput
        type="number"
        formControlName="TRAININGNUMDAYS"
        matTooltip="{{ toolTipList ? toolTipList.TRAININGNUMDAYS?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.TRAININGNUMDAYS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.TRAININGNUMDAYS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.TRAININGNUMDAYS?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TRAININGTOPIC),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TRAININGTOPIC),
      }"
    >
      <mat-label>Topic</mat-label>
      <input
        name="TRAININGTOPIC "
        formControlName="TRAININGTOPIC"
        matInput
        matTooltip="{{ toolTipList ? toolTipList.TRAININGTOPIC?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.TRAININGTOPIC) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.TRAININGTOPIC.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.TRAININGTOPIC?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TRAININGCONTRACTSIGNEDDATE),
        'has-warning': $safeNavigationMigration(
          errorWarningData.Warning?.TRAININGCONTRACTSIGNEDDATE
        ),
      }"
    >
      <mat-label>Contract Signed Date</mat-label>
      <input
        formControlName="TRAININGCONTRACTSIGNEDDATETEXT"
        (dateInput)="ExpirtyDateClick('input', $event)"
        (dateChange)="ExpirtyDateClick('change', $event)"
        matInput
        [matDatepicker]="ExpirtyDate"
        matTooltip="{{ toolTipList ? toolTipList.TRAININGCONTRACTSIGNEDDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="ExpirtyDate"></mat-datepicker-toggle>
      <mat-datepicker #ExpirtyDate></mat-datepicker>
      @if (testBool && toolTipList.TRAININGCONTRACTSIGNEDDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.TRAININGCONTRACTSIGNEDDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.TRAININGCONTRACTSIGNEDDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
</div>
